module.exports = __webpack_public_path__ + "static/media/Intersection 28.82090f42.png";